export default "__VITE_ASSET__TNIt3wAp__"